var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from 'react';
import { HeaderCell } from './HeaderCell';
import { normalize } from './SortSettings';
import { ColumnResizer } from '../drag/ColumnResizer';
import { ColumnDraggable } from '../drag/ColumnDraggable';
/**
 * @hidden
 */

var sortSeqMap = {
  true: {
    'asc': 'desc',
    'desc': '',
    '': 'asc'
  },
  false: {
    'asc': 'desc',
    'desc': 'asc',
    '': 'asc'
  }
};
/**
 * @hidden
 */

var ariaSortMap = {
  'none': 'none',
  'asc': 'ascending',
  'desc': 'descending'
};
/**
 * @hidden
 */

var HeaderRow = function (_super) {
  __extends(HeaderRow, _super);

  function HeaderRow() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.cellClick = function (e, column) {
      e.preventDefault();

      if (!_this.props.sortChange) {
        return;
      }

      var _a = normalize(_this.props.sortable || false, column.sortable || false),
          allowUnsort = _a.allowUnsort,
          mode = _a.mode;

      var oldDescriptor = (_this.props.sort || []).filter(function (d) {
        return d.field === column.field;
      })[0];
      var dir = sortSeqMap[allowUnsort][oldDescriptor && oldDescriptor.dir || ''];
      var newDescriptor = mode === 'single' ? [] : (_this.props.sort || []).filter(function (d) {
        return d.field !== column.field;
      });

      if (dir !== '' && column.field) {
        newDescriptor.push({
          field: column.field,
          dir: dir
        });
      }

      _this.props.sortChange(e, newDescriptor, column.field);
    };

    _this.cells = function (rowIndexes) {
      return rowIndexes.map(function (columnIndex, index) {
        var column = _this.props.columns[columnIndex];
        var columnResize = _this.props.columnResize;
        var resizable = columnResize && columnResize.resizable && column.resizable;
        var sortable = _this.props.sortable && column.sortable;
        var sortIndex = _this.props.sort ? _this.props.sort.findIndex(function (s) {
          return s.field === column.field;
        }) : -1;
        var sortDir = sortIndex >= 0 ? _this.props.sort[sortIndex].dir || 'none' : 'none';
        var headerCellProps = {
          field: column.field,
          onClick: sortable && function (e) {
            return _this.cellClick(e, column);
          } || undefined,
          selectionChange: _this.props.selectionChange,
          title: column.title,
          selectionValue: column.headerSelectionValue,
          render: _this.props.cellRender,
          children: _this.sortIcon(sortIndex)
        };

        var className = (column.kFirst ? 'k-first ' : '') + _this.cellClass(column.field, column.headerClassName, column.locked);

        var style = column.locked !== undefined ? {
          left: column.left,
          right: column.right,
          borderRightWidth: column.rightBorder ? '1px' : ''
        } : {};
        var ColumnMenu = column.columnMenu || _this.props.columnMenu;
        return React.createElement("th", {
          "aria-sort": sortable ? ariaSortMap[sortDir] : undefined,
          key: index,
          colSpan: column.colSpan,
          rowSpan: column.rowSpan,
          className: className,
          style: style
        }, ColumnMenu && React.createElement(ColumnMenu, {
          sort: _this.props.sort,
          onSortChange: _this.props.sortChange,
          filter: _this.props.columnMenuFilter,
          onFilterChange: _this.props.columnMenuFilterChange,
          field: column.field
        }), column.headerCell && React.createElement(column.headerCell, __assign({}, headerCellProps)) || React.createElement(HeaderCell, __assign({}, headerCellProps)), resizable && columnResize && React.createElement(ColumnResizer, {
          key: "ColumnResizer",
          resize: function resize(e, element, end) {
            return columnResize.dragHandler(e, column, element, end);
          }
        }));
      });
    };

    return _this;
  }

  HeaderRow.prototype.cellClass = function (field, headerClassName, locked) {
    var result = "k-header" + (locked ? ' k-grid-header-sticky' : '') + (headerClassName ? ' ' + headerClassName : '');

    if (this.props.sort && this.props.sort.some(function (descriptor) {
      return descriptor.field === field;
    })) {
      result += ' k-sorted';
    }

    return result;
  };

  HeaderRow.prototype.sortIcon = function (sortIndex) {
    if (!this.props.sort) {
      return null;
    }

    return sortIndex >= 0 && [React.createElement("span", {
      key: 1,
      className: 'k-icon k-i-sort-' + this.props.sort[sortIndex].dir + '-sm'
    }), this.props.sort.length > 1 && React.createElement("span", {
      key: 2,
      className: "k-sort-order"
    }, sortIndex + 1)];
  };

  HeaderRow.prototype.render = function () {
    var _this = this;

    return this.props.columnsMap.map(function (rowIndexes, i) {
      return _this.props.pressHandler && React.createElement(ColumnDraggable, {
        key: i,
        pressHandler: _this.props.pressHandler,
        dragHandler: _this.props.dragHandler,
        releaseHandler: _this.props.releaseHandler
      }, _this.cells(rowIndexes)) || React.createElement("tr", null, _this.cells(rowIndexes));
    });
  };

  return HeaderRow;
}(React.Component);

export { HeaderRow };